/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
// import { useBlockProps } from '@wordpress/block-editor';
import { useBlockProps	} from '@wordpress/block-editor';
/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {Element} Element to render.
 */
export default function save({attributes, props}) {
	const {
		k2_total_courses, 
        SelectedK2Course, 
        no_of_students, 
        LDdateKeys, 
        DEldWidth,
        DEldHeight,
        LDdateValues,
        DElsLineColor,
        DELDgraphAlignment,
        LDChartid
    } = attributes;

	const chartVal = JSON.stringify(LDdateValues);
	const chartKeys = JSON.stringify(LDdateKeys);
    let graphAlignment = {
        display:'flex',
        justifyContent:DELDgraphAlignment
    }
    let CardStyles = {
        width: DEldWidth+"px",
        height:DEldHeight+"px"
    }

	return (
		<div {...useBlockProps.save()} style={graphAlignment}>
            <div class="K2-LD-chart-main-parent-container" style={CardStyles} data-keys={chartKeys} data-chartid={LDChartid} data-values={chartVal} data-graphColor={DElsLineColor} >
                <canvas role="img" id={LDChartid} width="250" height="250"></canvas>
            </div>
		</div>
	);
}
